<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;">
					<h4 style="font-weight: bold; margin-bottom: 10px">{{$store.state.lang.text.withdraw[$store.state.lang.language]}}</h4>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-60 md-small-size-50 md-medium-size-50 md-size-50">
				<div class="verification__box">
					<div class="attach__wrap">
						 <select v-model="select" @change="changeMethod()">
							  <option value="">{{$store.state.lang.text.choose_withdraw_method[$store.state.lang.language]}}</option>
							  <option v-for="method in method_withdraw" :value="method.id">{{method.type}}</option>
						 </select>
					</div>
			  </div>
			</div>
			<div class="md-layout-item md-xsmall-size-40 md-small-size-50 md-medium-size-50 md-size-50">
				<div class="verification__box">
					<div class="attach__wrap">
						 <select v-model="currency" @change="changeMethod()">
							  <option value="usd">USD ($)</option>
							  <option value="khr">KHR (៛)</option>
						 </select>
					</div>
			  </div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<input v-if="currency == 'usd'" type="number" v-model="withdraw.amount" :placeholder="$store.state.lang.text.withdraw_amount[$store.state.lang.language]">
							<input v-if="currency == 'khr'" type="number" v-model="withdraw.amount" :placeholder="$store.state.lang.text.withdraw_amount_khr[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp"><input type="text" v-model="withdraw.account_name" :placeholder="$store.state.lang.text.bank_account_name[$store.state.lang.language]"></div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp"><input type="text" v-model="withdraw.account_number" :placeholder="$store.state.lang.text.bank_number[$store.state.lang.language]"></div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div style="padding: 10px 0 0">
					<table>
						<tr>
							<td>ដកប្រាក់ចំនួន</td>
							<td style="width: 50px;text-align: center;">:</td>
							<td>
								<b><span v-if="String(withdraw.amount).length >0">
									<span v-if="currency == 'khr'"><b>{{config.moneylify(withdraw.amount / 4100)}}</b></span>
									<span v-else><b>{{config.moneylify(withdraw.amount)}}</b></span>
								</span>
									<span v-else>-</span></b>
							</td>
						</tr>
						<tr>
							<td>ទឹកប្រាក់ទទួលបាន</td>
							<td style="width: 50px;text-align: center;">:</td>
							<td>
								<span v-if="String(withdraw.amount).length >0">
									<span v-if="currency == 'khr'"><b>{{config.moneylify(withdraw.amount, currency)}}</b> (1USD = 4100KHR)</span>
									<span v-else><b>{{config.moneylify(withdraw.amount)}}</b></span>
								</span>
								<span v-else><b>-</b></span>
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="form__tabs__wrap">
					<form>
						<div class="create__btn"><a class="cmn--btn" @click="requestWithdraw()" style="margin-top: 5px"><span>{{$store.state.lang.text.withdraw[$store.state.lang.language]}}</span></a></div>
					</form>
				</div>
			</div>
		</div>
		<Confirm :active.sync="confirmActive" :title.sync="$store.state.lang.text.confirm_withdraw[$store.state.lang.language]" @onCancel="cancelWithdraw" @onConfirm="requestWithdraw"/>
	</div>
</template>

<script>

	import Confirm from '@/components/Confirm';

	export default {
		components: {
			Confirm
		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.getPayment();
			this.getUser();
		},
		watch: {
			'withdraw.amount': function() {
				this.validateAmount();
			}
		},
		methods: {
			validateAmount() {
				if(this.currency == 'khr') {
					if(parseFloat(this.withdraw.amount) > parseInt(parseFloat(this.currentBalance * 4100) * 100) /100) {
						this.withdraw.amount = parseInt(parseFloat(this.currentBalance * 4100) * 100) /100;
					}
				} else {
					if(parseFloat(this.withdraw.amount) > parseInt(parseFloat(this.currentBalance) * 100) /100) {
						this.withdraw.amount = parseInt(parseFloat(this.currentBalance) * 100) /100;
					}
				}
			},
			getUser() {
				this.$http.get(this.config.api + "/user/authed/user/get_data").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.withdraw.payment_id = res.body.data.bank_type_id == null ? "" : res.body.data.bank_type_id
						this.withdraw.payment_type = res.body.data.bank_type
						this.select = res.body.data.bank_type_id == null ? "" : res.body.data.bank_type_id
						this.withdraw.account_name = res.body.data.account_name
						this.withdraw.account_number = res.body.data.account_number
						this.currentBalance = res.body.data.balance
					}
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/user/authed/payment/get_data").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.method_withdraw = res.body.data.method_withdraw;
					}
				})
			},
			requestWithdraw() {

				if(this.withdraw.payment_type.length > 0 && String(this.withdraw.amount).length >0 &&
				parseFloat(this.withdraw.amount) == this.withdraw.amount &&
				this.withdraw.account_name.length > 0 && this.withdraw.account_number.length > 0) {

					if(this.confirmActive) {
						this.confirmActive = false;
						this.$store.state.authentication.loading = true;

						let amount = this.withdraw.amount;
						let account_number = this.withdraw.account_number;
						let account_name = this.withdraw.account_name;
						this.withdraw.amount = "";
						this.withdraw.account_number = "";
						this.withdraw.account_name = "";

						this.$http.post(this.config.api + "/user/authed/payment/withdraw", {
							payment_id: this.withdraw.payment_id,
							payment_type: this.withdraw.payment_type,
							amount: amount,
							currency: this.currency,
							account_name: account_name,
							account_number: account_number
						}).then(res => {
							this.$store.state.authentication.loading = false;
							if (res.body.status == 'success') {
								this.$router.push("/account/transaction");
								this.$notification.notify(this.$store.state.lang.text.withdraw_success[this.$store.state.lang.language]);
							}
						})
					} else {
						this.confirmActive = true;
					}
				} else {
					this.$notification.notify(this.$store.state.lang.text.pleaseFill[this.$store.state.lang.language]);
				}
			},
			changeMethod() {
				this.validateAmount();
				if(this.select.length == "") {
					this.withdraw.payment_type = "";
					this.withdraw.payment_id = "";
				} else {
					for(let i = 0; i<this.method_withdraw.length; i++) {
						if(this.method_withdraw[i].id == this.select) {
							this.withdraw.payment_type = this.method_withdraw[i].type;
							this.withdraw.payment_id = this.method_withdraw[i].id;
						}
					}
				}

			},
			cancelWithdraw() {
				this.confirmActive = false;
			}

		},
		computed: {
		},
		data() {
			return {
				loaded: false,
				uploading: false,
				preview: "",
				select: "",
				currency: "usd",
				currentBalance: 0,
				withdraw: {
					payment_id: "",
					payment_type: "",
					amount: "",
					account_number: "",
					account_name: ""
				},
				confirmActive: false,
				method_withdraw: []
			}
		}
	}
</script>
<style>
	.deposit-list-menu {
		cursor:pointer; border-radius: 15px;padding: 14px; margin-bottom: 15px;background-color: var(--secondary-color);
	}
	.deposit-list-menu-left {
		min-width: calc(30% - 15px) !important;
		max-width: calc(30% - 15px) !important;
		margin-right: 15px !important;
	}
	@media (min-width: 945px) and (max-width: 1264px) {
		.deposit-list-menu-left {
			min-width: calc(40% - 15px) !important;
			max-width: calc(40% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (min-width: 601px) and (max-width: 944px) {
		.deposit-list-menu-left {
			min-width: calc(50% - 15px) !important;
			max-width: calc(50% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (max-width: 600px) {
		.deposit-list-menu-left {
			min-width: 100% !important;
			max-width: 100% !important;
			margin-right: 0px !important;
		}
	}

</style>



// WEBPACK FOOTER //
// src/pages/Account/Withdraw.vue